import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory } from '@fortawesome/pro-duotone-svg-icons';
import DropzoneControl from './upload';
import HistoryModal from './history/UploadHistory';

function BatchUpload({ showUploadHistory }) {
  return (
    <>
      <main className="p-5">
        <Row>
          <Col>
            <h2 className="mb-3 font-weight-bold">Batch Upload</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="ms-auto">
              <Button color="darkgray" onClick={showUploadHistory} className="ms-4">
                <FontAwesomeIcon icon={faHistory} size="lg" className="me-2" />
                View Upload History
              </Button>
            </div>
            <DropzoneControl />
          </Col>
        </Row>
      </main>

      <HistoryModal />
    </>
  );
}

const mapDispatchToProps = {
  showUploadHistory: () => ({ type: 'OPEN_BATCH_HISTORY' }),
};

export default connect(null, mapDispatchToProps)(BatchUpload);
